import { render, staticRenderFns } from "./SalesmanChangePwd.vue?vue&type=template&id=6b8f3b7a&scoped=true&"
import script from "./SalesmanChangePwd.vue?vue&type=script&lang=js&"
export * from "./SalesmanChangePwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8f3b7a",
  null
  
)

export default component.exports